import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const UOMInfoComponent = ({handleInnerFormItemChange, selectedAnnouncement, handleInnerFormChange,organizationUnits}: any) => (
    <>
     <AccordionContainer
                  child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    
       
<InputContainer
   label="Limited To OrganizationUnit" 
                    labelField="Name"
                    list={organizationUnits}
                    onValueChange={( newValue: any) => {
                      const valueData: any = newValue.map((option: any) => option?.value || '')
                      handleInnerFormItemChange(
                        valueData,
                        'LimitedToOrganizationMappings.LimitedToOrganizationUnitIds',
                        selectedAnnouncement?.LimitedToOrganizationMappings
                      );
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={selectedAnnouncement?.LimitedToOrganizationMappings?.LimitedToOrganizationUnitIds}
/>

     </div>}
                  expandedPanel="Organization Unit Info"
                  headerTitle="Organization Unit Info"
                />
    </>
)